// extracted by mini-css-extract-plugin
module.exports = {"sorting-menu":"sorting-menu___3qGpd","title":"title___3xLYE"};